$(function() {
    
    WebFont.load({
        google: {
            families: ['Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i']
        }
    });
});